import { EventsPage as EventsPageComponent } from "../features/events";

export function EventsPage() {
  return <EventsPageComponent />;
}
